export enum DirectionMode {
  TRANSIT = 'transit',
  WALKING = 'walking',
  BICYCLING = 'bicycling'
}
